import React, {Component} from 'react';
import '../../../../scss/custom-repost-buttons.scss'

export default class RepostButtons extends React.Component{
    constructor(props) {
        super(props);
    }

    render() {
        return <div className="repost-buttons">
            <button className="repost-button btn btn-sm linkedin-repost-button"><i
                className="fa fa-linkedin"/><b> Del</b></button>
            <button className="repost-button btn btn-sm facebook-repost-button"><i
                className="fa fa-facebook-official"/><b> Del</b> 0
            </button>
            <button className="repost-button btn btn-sm twitter-repost-button"><i
                className="fa fa-twitter"/><b> Tweet</b></button>
        </div>;
    }
};






// WEBPACK FOOTER //
// ./web/src/components/common/view/RepostButtons.jsx